import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
  statisticsAction,
  statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const AttendanceLeave = (props) => {
  const sparkline1 = React.createRef();
  const sparkline2 = React.createRef();
  const sparkline3 = React.createRef();
  const sparkline4 = React.createRef();


  const handleStatistics = (e) => {
    statisticsAction(e)
  }
  const closeStatistics = (e) => {
    statisticsCloseAction(e)
  }

  const { fixNavbar, statisticsOpen, statisticsClose } = props;
  const defaultChecked = false;

  const [selectedItems, setSelectedItems] = useState([]);
  const [isChecked, setIsChecked] = useState({ defaultChecked });


  const [checkbox, setCheckbox] = useState([]);

  const history = useHistory();
  // const [data, setData] = useState([]);
  // const [leavedetaildata, setLeaveDetailData] = useState([]);
  


  const { search } = useLocation();
  const searchparams = new URLSearchParams(search);
  const param = searchparams.get("id");
  const attn_date = searchparams.get("attn_date");

  // alert(attn_date);
  //const handleChange = (e) => setCheckbox(e.target.checked);



    const [formData, setFormData] = useState({
from_date: attn_date,
to_date: attn_date,
user_id:param,
});
const [options, setData] = useState([]); 
const [table, setTable] = useState([]); 
const [settype, setType] = useState([]);
const [setcount, setCount] = useState([]);
const [setcompoff, setComp] = useState([]);
const [setcompcount, setCompCount] = useState([]);

const [sample, setlist] = useState([]); 

const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);

const [user_info, setinfo] = useState([]);





const handleChange = (e) => {
  
const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
const imageStyle = {
  width: '300px',
  height: 'auto',
  borderRadius: '10px',
}








// useEffect(async() => {
//   setLoading(true);
//   setError(null); // Clear any previous errors
//   try {
//     const response = await fetch('http://127.0.0.1:8000/api/user_info');
//     if (!response.ok) {
//       throw new Error('Network response was not ok');
//     }
//     const result = await response.json();
//     console.log("haiiiiii")
//     console.log(result.data);
//       setinfo(result.data[0]);
//   } catch (err) {
//     setError(err.message);
//   } finally {
//     setLoading(false);
//   }
// },[]);

useEffect(() => {
  axios.get(API_BASE_URL + '/user_info', {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
  })

    // .then(res =>console.log(res.data))
    .then(res => setinfo(res.data))
    .catch(err => console.log(err));
}, [])

useEffect(() => {
  
  
  axios
    .get(API_BASE_URL+'/leavedetails/'+ param, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {
      setTable(response.data.data.table);
      setCount(response.data.data);

     console.log(response.data.data.sl);
    
      setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
}, []);



useEffect(() => {
  
  axios
    .get(API_BASE_URL+'/leavetypelist', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {
      setType(response.data.data.leave_type);
     
    
      setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
}, []);






const compoffchangeoption= async(dateval) => {
  setLoading(true);
  setError(null); // Clear any previous errors

 

 if(dateval==5)
 {

   try {
  
    const response = await axios.get(API_BASE_URL +'/compoff/'+param+'/'+attn_date, {
     
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

        'Content-Type': 'application/json', // Ensure JSON data is sent
      },
    });
  
    // console.log("Response received:");
    // console.log(response.data.data.comp_table);
  
    setComp(response.data.data.comp_table);
    setCompCount(response.data.data.count);

  } catch (err) {
    // Handle errors (both network and server)
    setError(err.response ? err.response.data.message : err.message);
  } finally {
    setLoading(false); // Stop loading spinner or indicator
  }

 }

 
  
};





const handleSubmit =  async (e) => {

e.preventDefault(); // Prevent the default form submission

console.log('Form submitted:', formData);



axios.post(API_BASE_URL+'/add_leave_request' ,formData, {
  headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

  'Content-Type': 'application/json', // Ensure JSON data is sent
},
}).then(response => {
   //  console.log(response.data);
        //  console.log(response.data.message);
        // })
        var status =response.data.status;
            if (status=='success')
            {
                toast.success(response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
                   setTimeout(() => {
					return history.push("Attendance");
				}, 3000);
                   
            }
           else if (status=='error')
              {
                  toast.error(response.data.message, {
                      position: "bottom-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                      });
                      // setTimeout(() => {
                      //   window.location.reload(); // Reload the page after delay
                      // }, 3000);
                     
              }
           
        }).catch(error => {
        
            // console.log(error);
            // console.log(error.response.data.message);
            toast.error(error.response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
         });




};



const call=async(event) => { 
  const value= event.target.value;

  compoffchangeoption(value);
}




  return (
    <>


      <div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<ToastContainer/>
<div className="container-fluid">


<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">

<span></span>
<h3 className="card-title d-flex align-items-center mb-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
<i className="fa fa-user mr-2" style={{ fontSize: "20px" }} />
Employee Name : {setcount.employee_name} / Employee Id : {setcount.employee_id}
</h3>



</div>

</div>


</div>



<div className="row">
<div className="col-lg-3 col-md-4">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available SL</span>
<h3 className="mb-0">

<span className="counter">	<CountUp  /> {setcount.sl}</span>
</h3>
</div>
<div className="w_chart">
<div id="mini-bar-chart1" className="mini-bar-chart" />
</div>
</div>
</div>
{/* 
<div className="w_chart">
<span
ref={sparkline1}
id="mini-bar-chart1"
className="mini-bar-chart"
></span>
</div>
*/}
</div>
<div className="col-lg-3 col-md-6">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available CL</span>
<h3 className="mb-0">
{/* /<CountUp end={user_info.leave_available} /> */}
<span >{setcount.cl}</span>
</h3>
</div>
<div className="w_chart">
<span
ref={sparkline2}
id="mini-bar-chart2"
className="mini-bar-chart"
/>
</div>
</div>
</div>
</div>
<div className="col-lg-3 col-md-6">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available Paternity</span>
<h3 className="mb-0 counter">	<CountUp end={setcount.pl} />{setcount.pl}</h3>
</div>
<div className="w_chart">
<span
ref={sparkline3}
id="mini-bar-chart3"
className="mini-bar-chart"
/>
</div>
</div>
</div>
</div>

</div>

<form onSubmit={handleSubmit}>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix">
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Leave Type</label><span className="form-required">*</span>



<select  className="form-control custom-select" id="leave_type"   name='leave_type' value={formData.leave_type} onChange={(e)=>{handleChange(e);compoffchangeoption(e.target.value)}}>
        <option value="" disabled>Select Leave Type</option>
        <option></option>

        {settype.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

</div>
</div>
<div className="col-lg-4 col-md-12">
<label>From Date</label><span className="form-required">*</span>

<div className="form-group">
<input type='hidden' name="user_id" value={formData.user_id}
 onChange={handleChange}/>
  <input type='text' className='form-control' name="from_date" placeholder='Select Date' value={formData.from_date} disabled
 onChange={handleChange}/>
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-lg-4 col-md-12">
<label>To Date</label><span className="form-required">*</span>

<div className="form-group">



<input type='text'  className='form-control' name="to_date" value={formData.to_date} disabled
 onChange={handleChange} />
{/* <Datepicker name="todate" value={formData.todate}
onChange={handleChange}></Datepicker> */}
{/* <div className="input-"  name="to_date" value={formData.to_date}
onChange={handleChange}>


</div> */}

<input type='hidden'  className='form-control' name="user_id" value={formData.user_id}
 />

</div>
</div>


{formData.leave_type==5 && 
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Select Compensatory Off  ({setcompcount})</label><span className="form-required">*</span>



<select  className="form-control custom-select" id="combooff_days"   name='combooff_days' value={formData.combooff_days} onChange={handleChange}>
        <option value="" disabled> Comp Off</option>
       < option></option>
       {setcompoff.length!=0 &&
       ( setcompoff.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        )))}
      </select>

</div>
</div>
}

<div className="col-lg-12 col-md-12">
<label>Reason</label><span className="form-required">*</span>

<div className="form-group">
<textarea
rows={4}
type="text"
className="form-control"
placeholder="Reason"
name="reason" value={formData.reason}
onChange={handleChange}
/>
</div>
</div>
</div>
<button type="submit" className="btn btn-round btn-primary">
Save
</button>

</div>

</div>


</div>

</form>

</div>
</div>


</div>
</div>








    </>
  );
}

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
  statisticsOpen: state.settings.isStatistics,
  statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
  statisticsAction: (e) => dispatch(statisticsAction(e)),
  statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(AttendanceLeave);